import type { SettingsState } from './types';

import { CONFIG } from 'src/global-config';

// ----------------------------------------------------------------------

const baseSettings: Omit<SettingsState, 'navLayout' | 'primaryColor'> = {
  mode: 'light',
  direction: 'ltr',
  contrast: 'default',
  navColor: 'integrate',
  compactLayout: true,
  fontSize: 16,
  fontFamily: 'Public Sans Variable',
  version: CONFIG.appVersion,
};

export const defaultSettingsMCH: SettingsState = {
  ...baseSettings,
  navLayout: 'horizontal',
  primaryColor: 'default',
};

export const defaultSettingsICS: SettingsState = {
  ...baseSettings,
  navLayout: 'vertical',
  primaryColor: 'preset1',
};

let defaultSettings: SettingsState;

if (import.meta.env.VITE_STATE_NAME === 'mch') {
  defaultSettings = defaultSettingsMCH;
} else {
  defaultSettings = defaultSettingsICS;
}

export { defaultSettings };
